var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"copy":_vm.captureCopy}},[_vm._t("default"),_vm._v(" "),_c('LimitActionModal',{attrs:{"show":_vm.showBlocker,"action-permissions":_vm.copyPermissions},on:{"update:show":function($event){_vm.showBlocker=$event}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }